(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["accordion-item"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('accordion-item')) {
    class AccordionItem extends HTMLElement {
      connectedCallback() {
        this.trigger = this.querySelector('.accordion-item__trigger');
        this.trigger?.addEventListener('click', () => this.toggle());
      }

      toggle() {
        const isOpen = this.hasAttribute('open');
        this.toggleAttribute('open', !isOpen);
        this.trigger?.setAttribute('aria-expanded', String(!isOpen));
      }
    }
    customElements.define('accordion-item', AccordionItem);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cart-toast"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cart-toast')) {
    class CartToast extends HTMLElement {
      connectedCallback() {
        this.panel = this.querySelector('[data-cart-toast-panel]');
        this.message = this.querySelector('[data-cart-toast-message]');
        this.hideTimer = null;

        this.onItemAdded = (event) => this.show(event.detail);
        document.addEventListener('cart:item-added', this.onItemAdded);
      }

      disconnectedCallback() {
        document.removeEventListener('cart:item-added', this.onItemAdded);
        clearTimeout(this.hideTimer);
      }

      show(detail) {
        var text = 'Added to cart';
        if (detail && detail.items && detail.items.length) {
          text = detail.items.length + ' items added to cart';
        } else if (detail && detail.product_title) {
          text = detail.product_title + ' added to cart';
        }

        this.message.textContent = text;
        this.panel.hidden = false;
        // Force layout so the transition runs even on rapid re-triggers.
        void this.panel.offsetWidth;
        this.panel.classList.add('is-visible');

        clearTimeout(this.hideTimer);
        this.hideTimer = setTimeout(() => this.hide(), 3200);
      }

      hide() {
        this.panel.classList.remove('is-visible');
        var panel = this.panel;
        setTimeout(function () {
          panel.hidden = true;
        }, 250);
      }
    }
    customElements.define('cart-toast', CartToast);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cookie-consent"] && !Shopify.designMode) return;
  try {
    (function () {
    var KEY = 'blore-foods-cookie-consent';
    var el = document.querySelector('[data-cookie-consent]');
    if (!el) return;

    if (!localStorage.getItem(KEY)) {
      el.hidden = false;
    }

    el.querySelector('[data-cookie-accept]')?.addEventListener('click', function () {
      localStorage.setItem(KEY, '1');
      el.hidden = true;
    });

    el.querySelector('[data-cookie-decline]')?.addEventListener('click', function () {
      localStorage.setItem(KEY, '0');
      el.hidden = true;
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["quantity-selector"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function (event) {
    var decrease = event.target.closest('[data-quantity-decrease]');
    var increase = event.target.closest('[data-quantity-increase]');
    if (!decrease && !increase) return;

    var wrapper = event.target.closest('[data-quantity-selector]');
    var input = wrapper && wrapper.querySelector('[data-quantity-input]');
    if (!input) return;

    var value = parseInt(input.value, 10) || 1;
    value = decrease ? Math.max(1, value - 1) : value + 1;
    input.value = value;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["quick-view-modal"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('quick-view-modal')) {
    class QuickViewModal extends HTMLElement {
      connectedCallback() {
        this.body = this.querySelector('[data-quick-view-body]');
        this.titleEl = this.querySelector('[data-quick-view-title]');
        this.link = this.querySelector('[data-quick-view-link]');

        this.querySelectorAll('[data-quick-view-close]').forEach((el) => {
          el.addEventListener('click', () => this.close());
        });

        document.addEventListener('keydown', (event) => {
          if (event.key === 'Escape' && !this.hidden) this.close();
        });

        document.addEventListener('click', (event) => {
          const trigger = event.target.closest('[data-quick-view-toggle]');
          if (trigger) this.open(trigger.dataset.productHandle);
        });
      }

      async open(handle) {
        if (!handle) return;
        this.hidden = false;
        document.body.style.overflow = 'hidden';
        this.body.innerHTML = window.BloreSkeleton
          ? window.BloreSkeleton.quickView()
          : '<p class="quick-view__loading">Loading…</p>';
        this.link.href = `/products/${handle}`;

        try {
          const response = await fetch(`/products/${handle}?section_id=main`);
          const html = await response.text();
          const parsed = new DOMParser().parseFromString(html, 'text/html');
          const top = parsed.querySelector('.product-page__top');
          const titleEl = parsed.querySelector('.product-page__title');

          if (this.titleEl && titleEl) this.titleEl.textContent = titleEl.textContent;

          if (top) {
            this.body.innerHTML = '';
            this.body.appendChild(top);
          } else {
            // Fallback: some themes use the section file name as section_id
            const retry = await fetch(`/products/${handle}?section_id=main-product`);
            const retryHtml = await retry.text();
            const retryParsed = new DOMParser().parseFromString(retryHtml, 'text/html');
            const retryTop = retryParsed.querySelector('.product-page__top');
            if (retryTop) {
              if (this.titleEl) {
                const retryTitle = retryParsed.querySelector('.product-page__title');
                if (retryTitle) this.titleEl.textContent = retryTitle.textContent;
              }
              this.body.innerHTML = '';
              this.body.appendChild(retryTop);
            } else {
              this.body.innerHTML = '<p class="quick-view__loading">Unable to load product.</p>';
            }
          }
        } catch (error) {
          this.body.innerHTML = '<p class="quick-view__loading">Unable to load product.</p>';
        }
      }

      close() {
        this.hidden = true;
        document.body.style.overflow = '';
      }
    }
    customElements.define('quick-view-modal', QuickViewModal);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["scroll-top"] && !Shopify.designMode) return;
  try {
    (function () {
    var button = document.querySelector('[data-scroll-top]');
    if (!button) return;

    var onScroll = function () {
      button.classList.toggle('is-visible', window.scrollY > 480);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });

    button.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
